import { LineChart } from '@/components/charts/LineChart';
import { riskSeverityCardClass } from '@/sections/insights/metrics/constants/riskSeverityStyles';
import { RiskSeverity, SeverityDef } from '@/types';
import { omit } from '@/utils/lodash.util';

function BaseComponent({
  data,
  dot,
}: {
  data: {
    name: string;
    Critical: number;
    High: number;
    Medium: number;
    Low: number;
    Info: number;
  }[];
  dot?: boolean;
}) {
  return (
    <LineChart
      dot={dot}
      type="monotone"
      data={data}
      lines={Object.entries(omit(riskSeverityCardClass, 'E')).map(
        ([label, { dotClassName, lineClassName }]) => {
          return {
            dotClassName,
            dataKey: SeverityDef[label as RiskSeverity],
            lineClassName,
          };
        }
      )}
      legend
    />
  );
}

const sampleData = [...Array(5).keys()].map(i => ({
  name: `Jan ${i + 1}`,
  Critical: Math.floor(Math.random() * 50),
  High: Math.floor(Math.random() * 50),
  Medium: Math.floor(Math.random() * 50),
  Low: Math.floor(Math.random() * 50),
  Info: Math.floor(Math.random() * 50),
}));

export function RemediatedVulnerabilityOverTimeExample() {
  return <BaseComponent data={sampleData} dot={true} />;
}
